module.exports = __webpack_public_path__ + "static/media/logo-bottom.478e7b11.png";